import React from "react";
import {
  Box,
  HStack,
  VStack,
  Text,
  Image,
  useColorModeValue,
  IconButton,
} from "@chakra-ui/react";
import { usdt } from "../../config";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";

const HorizontalPositionsGrid = ({
  positionsDetails,
  collateralTokens,
  indexTokens,
  prices,
  tokenImages,
  link,
  usdc,
  sellLimit,
  _lossLimit,
  usdc_e,
  showDetails,
  toggleDetails,
  weth,
  wbtc,
  btc,
}) => {
  return (
    <VStack spacing={2} align="stretch" mt={2} w="100%">
      {positionsDetails.map((position) => {
        const collateralTokenName =
          collateralTokens[position.positionIndex] === link
            ? "link"
            : collateralTokens[position.positionIndex] === usdc
            ? "usdc"
            : collateralTokens[position.positionIndex] === usdt
            ? "usdt"
            : collateralTokens[position.positionIndex] === usdc_e
            ? "usdc.e"
            : collateralTokens[position.positionIndex] === weth
            ? "weth"
            : collateralTokens[position.positionIndex] === wbtc
            ? "wbtc"
            : collateralTokens[position.positionIndex] === btc
            ? "btc"
            : "unknown";

        const indexTokenName =
          indexTokens[position.positionIndex] === link
            ? "link"
            : indexTokens[position.positionIndex] === usdc
            ? "usdc"
            : indexTokens[position.positionIndex] === weth
            ? "weth"
            : indexTokens[position.positionIndex] === wbtc
            ? "wbtc"
            : indexTokens[position.positionIndex] === btc
            ? "btc"
            : "unknown";

        const tokenImage = tokenImages[indexTokenName] || "./eth.png";
        const tokenDisplay =
          indexTokenName === "usdc" ? "USDC.e" : indexTokenName.toUpperCase();
        const positionType = position.isLong ? "Long" : "Short";

        const collateralTokenDisplayName =
          collateralTokenName === "usdc_e"
            ? "USDC.e"
            : collateralTokenName.toUpperCase();
        const indexTokenDisplayName =
          indexTokenName === "usdc" ? "USDC.e" : indexTokenName.toUpperCase();
        return (
          <Box
            key={position.positionIndex}
            //p={1}
            //px={2}
            //py={2}
            mt={4}
            border='1px solid dodgerblue'
            shadow='dark-lg'
            //borderRadius="md"
            //boxShadow="sm"
            bg="white"
            fontSize="sm"
            fontFamily={'Sentinel'}
          >
            <HStack p={1} justify="space-between" align="center" spacing={3}>
              {/* Price Delta */}
              <Text
                color={position.hasProfit === "1" ? "green.500" : "red.500"}
                fontFamily="Sentinel"
                as='b'
              >
                {position.deltaPercentage} (${position.delta})
              </Text>

              {/* Token & Icon */}
              <HStack spacing={1}>
                <Image
                  src={tokenImage}
                  alt={indexTokenName}
                  boxSize="20px"
                  borderRadius="full"
                />
                <Text fontWeight="semibold">{tokenDisplay}</Text>
              </HStack>

              {/* Position Type */}
              <Text>{positionType}</Text>

              {/* Size & Collateral */}
              <Text>Entry: {position.entryPrice}</Text>
              <Text>Current: ${prices[position.positionIndex]}</Text>
              <Text>Collateral: ${position.collateral}</Text>
              <Text>{position.leverage}x</Text>
              <Text>Size: ${position.size}</Text>
              <IconButton
                icon={showDetails ? <ChevronUpIcon /> : <ChevronDownIcon />}
                onClick={toggleDetails}
                aria-label="Toggle Position Details"
                size="sm"
                //variant="unstyled"
                colorScheme="blue"
                variant={'outline'}
              />
            </HStack>
            {showDetails && (
              <Box bg='gray.200'>
                
              <HStack justify="space-between" align="center" spacing={3}>
                
                <Text>Sell Limit: {sellLimit} %</Text>
                <Text>Loss Limit: {_lossLimit} %</Text>
                <Text>Sell: ${position.sellPrice}</Text>
                <Text>Buy: ${position.buyPrice}</Text>
                <Text>Fees: {position.openClose}</Text>
                <Text>Profit/Risk: ${position.potential}</Text>
                <Text fontSize="xs">Last: {position.lastIncreasedTime}</Text>
                </HStack>
              </Box>
            )}
          </Box>
        );
      })}
    </VStack>
  );
};

export default HorizontalPositionsGrid;
